"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTableColumns = void 0;
const react_1 = require("react");
const user_settings_context_1 = require("../../../common/settings/user/user-settings-context");
const event_callback_hook_1 = require("../../../utils/event-callback-hook");
const update_effect_1 = require("../../../utils/update-effect");
const table_types_1 = require("../table-types");
const number_cell_1 = require("../cells/number-cell");
const boolean_cell_1 = require("../cells/boolean-cell");
function useTableColumns({ tableId, version, columns: providedColumns, }) {
    const columns = react_1.useMemo(() => addDefaults(providedColumns), [
        providedColumns,
    ]);
    const { getTableSettings, setTableSettings } = react_1.useContext(user_settings_context_1.UserSettingsContext);
    let settings;
    const defaultColumnsState = deriveColumnsState(columns);
    let initColumnsState = defaultColumnsState;
    if (tableId !== '') {
        settings = getTableSettings(tableId, version);
        if ((settings === null || settings === void 0 ? void 0 : settings.columnsState) !== undefined) {
            initColumnsState = settings === null || settings === void 0 ? void 0 : settings.columnsState;
        }
    }
    const [columnsState, setColumnsState] = react_1.useState(initColumnsState);
    const columnDialogRef = react_1.useRef(null);
    const openColumnDialog = event_callback_hook_1.useEventCallback(() => { var _a; return (_a = columnDialogRef.current) === null || _a === void 0 ? void 0 : _a.open(); });
    const closeColumnDialog = event_callback_hook_1.useEventCallback(() => { var _a; return (_a = columnDialogRef.current) === null || _a === void 0 ? void 0 : _a.close(); });
    const filteredColumns = react_1.useMemo(() => columnsState
        .map((state) => {
        const column = columns.find((column) => column.datakey === state.datakey);
        return column !== undefined ? { ...column, ...state } : undefined;
    })
        .filter((column) => column !== undefined)
        .map((column) => column)
        .filter((column) => column.visible || column.visible === undefined), [columns, columnsState]);
    /**
     * Updates user settings.
     */
    update_effect_1.useUpdateEffect(() => {
        const newSettings = {
            ...(settings !== null && settings !== void 0 ? settings : {}),
            columnsState,
            version,
        };
        setTableSettings(tableId, newSettings);
    }, [columnsState]);
    return {
        columnsState,
        defaultColumnsState,
        filteredColumns,
        setColumnsState,
        columnDialogRef,
        openColumnDialog,
        closeColumnDialog,
    };
}
exports.useTableColumns = useTableColumns;
function addDefaults(columns) {
    return columns.map((column) => ({
        align: deriveAlign(column.CellComponent),
        ...column,
    }));
}
function deriveAlign(CellComponent) {
    switch (CellComponent) {
        case boolean_cell_1.BooleanCell:
            return table_types_1.TableColumnAlign.CENTER;
        case number_cell_1.NumberCell:
            return table_types_1.TableColumnAlign.RIGHT;
        default:
            return table_types_1.TableColumnAlign.LEFT;
    }
}
/**
 * Derives default column states from supplied colums.
 */
function deriveColumnsState(columns) {
    return columns.map(({ visible = true, width, datakey }) => ({ visible, width, datakey }));
}
//# sourceMappingURL=table-columns-hook.js.map